export default handlerKey => ({
  mounted() {
    window.addEventListener('hashchange', this[handlerKey]);
  },
  destroyed() {
    window.removeEventListener('hashchange', this[handlerKey]);
  },
});
